import React, { Component } from 'react';
import ErrorDisplay from './ErrorDisplay';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    this.setState({ errorInfo });
    
    // If there's an onError prop, call it with the error
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    const { hasError, error } = this.state;
    const { 
      children, 
      fallback,
      title = 'Something went wrong',
      message = 'An unexpected error occurred in this component.',
      showDetails = process.env.NODE_ENV !== 'production',
      onRetry = this.handleRetry
    } = this.props;

    if (hasError) {
      // If a custom fallback is provided, use it
      if (fallback) {
        return typeof fallback === 'function' 
          ? fallback(error, this.handleRetry)
          : fallback;
      }

      // Otherwise, use the ErrorDisplay component
      return (
        <ErrorDisplay
          error={error}
          title={title}
          message={message}
          showDetails={showDetails}
          onRetry={onRetry === false ? null : onRetry}
        />
      );
    }

    // When there's no error, render children normally
    return children;
  }
}

export default ErrorBoundary; 